import {
  fileUpload as fileUploadApi,
  validateEmailAddress,
} from "../utility/apiCall";
export const fileUpload = async (payload) => {
  // console.log(payload);
  return await fileUploadApi("api/upload", "POST", payload);
};
export const validateEmail = async (payload) => {
  //update this call with common service call
  return await validateEmailAddress("api/validate-email", "POST", payload);
};



// WEBPACK FOOTER //
// ./src/services/fileUpload.js